export default "__VITE_ASSET__CP6hgDXe__"